<template>
  <div class="pediatric-growth-chart-card">
    <apexchart
      v-if="chartPayload"
      type="line"
      height="300"
      :options="chartPayload.options"
      :series="chartPayload.series"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts/src/vue3-apexcharts';
import { buildPediatricChart } from '../../../helpers/pediatricGrowthChart';

export default {
  name: 'PediatricGrowthChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    chart: {
      type: Object,
      required: true,
    },
    referenceStandard: {
      type: String,
      default: '',
    },
  },
  computed: {
    chartPayload() {
      if (!this.chart) {
        return null;
      }

      return buildPediatricChart(this.chart, this.referenceStandard);
    },
  },
};
</script>

<style scoped>
.pediatric-growth-chart-card {
  background: #fff;
  border: 1px solid #eff2f5;
  border-radius: 0.75rem;
  padding: 0.5rem 0.25rem 0;
}
</style>
